import PropTypes from 'prop-types';
import ModalExistek from './ModalExistek.jsx';

const Confirm = ({ isVisibleConfirm, cancelConfirm, onConfirm, message, title, okText = 'Delete' }) => {
    return (
        <ModalExistek
            title={title}
            open={isVisibleConfirm}
            onCancel={cancelConfirm}
            onOk={onConfirm}
            okText={okText}
            className={'modal-delete'}
        >
            <div>{message}. Are you sure?</div>
        </ModalExistek>
    );
};

Confirm.propTypes = {
    isVisibleConfirm: PropTypes.bool.isRequired,
    cancelConfirm: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    okText: PropTypes.string,
};
export default Confirm;
